const LISTE_CHARGE_TRAVAIL_TECHNIQUE = {
  title: 'Gestion de la charge de travail technique',
  breadcrumb: {
    liste: 'Gestion charge travail technique',
  },
  actions: {
    affecter: 'Affecter',
    addTechnicien: 'Ajouter un technicien',
  },
  tabs: {
    code: 'N° ordre de travail',
    type: 'Type',
    etat: 'Etat',
    dateSouhaite: 'Date souhaitée',
    datePlanification: 'Date de planification',
    dateRealisation: 'Date de réalisation',
    technicien: 'Technicien',
    montantHt: 'Montant HT',
    patrimoine: 'Patrimoine / adresse',
  },
  sansDate: 'Sans date de planification',
  ressources: 'Afficher la charge de travail ({nbRessources})',
  ressourceAndAffectationInfo: {
    ot: 'OT',
    title: 'Liste des charges de travail',
    noCharge: 'Aucune charge de travail',
    otNonAffecte: 'OT non affectés à un technicien',
    titleAffectation: 'Affectation à un technicien',
    nbOts: '{nbOt} OT(s)',
  },
  messages: {
    errors: {
      displayScraping: 'La société doit contenir un produit d\'affichage ainsi qu\'un produit de grattage.',
      villeRequired: 'La ville de l\'afficheur est obligatoire.',
      noOt: 'Vous n\'avez aucun ordre de travail à générer.',
    },
    sucess: {
      otCreate: 'Ordre(s) de travail généré(s) avec succès.',
    },
  },
  popUpAffecter: {
    title: 'Affecter à un technicien',
    messHeader: 'Voulez-vous vraiment affecter le/les ot(s) à ce technicien ?',
    sousTitle: 'Veuillez choisir un technicien et une date de planification',
    actions: {
      affecter: 'Affecter',
    },
    messages: {
      success: {
        affecter: 'Le/Les ot(s) ont été affecté(s) à un technicien avec succès.',
        desaffecter: 'Le/Les ot(s) ont été désaffecté(s) à un technicien avec succès.',
      },
    },
    technicien: 'Technicien',
    datePlanification: 'Date de planification',
  },
  popUpDesaffectation: {
    messHeader: 'Etes-vous sûr de vouloir désaffecter ces ots ?',
  },
};

export default LISTE_CHARGE_TRAVAIL_TECHNIQUE;
